import React from "react";
import { NavLink } from "react-router-dom";

const Navbar = () => {
  return (
    <div className="navbar">
      <div className="navbar-menu">
        <NavLink
          to={"/"}
          className={({ isActive }) =>
            isActive ? "menu-item-class active" : "menu-item-class passive"
          }
        >
          <div className="navbar-menu-item">
            <i class="ri-compass-line"></i>
            <span>Sağlık Rehberi</span>
          </div>
        </NavLink>
        <NavLink
          to={"/medical"}
          className={({ isActive }) =>
            isActive ? "menu-item-class active" : "menu-item-class passive"
          }
        >
          <div className="navbar-menu-item">
            <i class="ri-compass-line"></i>
            <span>Tıbbi ilgi alanları</span>
          </div>
        </NavLink>

        <NavLink
          to={"/contact-form"}
          className={({ isActive }) =>
            isActive ? "menu-item-class active" : "menu-item-class passive"
          }
        >
          <div className="navbar-menu-item">
            <i class="ri-phone-line"></i>
            <span>İlerişim formu</span>
          </div>
        </NavLink>
        <NavLink
          to={"/qna"}
          className={({ isActive }) =>
            isActive ? "menu-item-class active" : "menu-item-class passive"
          }
        >
          <div className="navbar-menu-item">
            <i class="ri-question-answer-line"></i>
            <span>Soru Cevap</span>
          </div>
        </NavLink>
        <NavLink
          to={"/menu"}
          className={({ isActive }) =>
            isActive ? "menu-item-class active" : "menu-item-class passive"
          }
        >
          <div className="navbar-menu-item">
            <i class="ri-grid-fill"></i>
            <span>Menü</span>
          </div>
        </NavLink>
      </div>
    </div>
  );
};

export default Navbar;
